const subvestSearchForm = document.querySelector('[data-subvest-search-form]');

if (subvestSearchForm) {
  const urlParams = new URLSearchParams(window.location.search);
  const scopeInput = subvestSearchForm.querySelector('[data-subvest-search-scope]');
  const subtypeInput = subvestSearchForm.querySelector('[data-subvest-search-subtype]');
  const currentQuery = urlParams.get('q') || '';
  const normalizedCurrentQuery = currentQuery.toLowerCase();
  const customerDisplayQuery = (urlParams.get('subvest_query') || '').trim().replace(/\s+/g, ' ');
  const inferredScope = normalizedCurrentQuery.includes('title:"cloth"')
    ? 'heritage'
    : normalizedCurrentQuery.includes('title:"patch"')
      ? 'patches'
      : normalizedCurrentQuery.includes('title:"ballcap"')
        ? 'ballcaps'
        : '';
  const inferredSubtype = ['ssbn', 'ssn', 'ss'].find((value) => normalizedCurrentQuery.includes(`title:"${value}"`)) || '';
  const requestedScope = urlParams.has('scope') ? urlParams.get('scope') : inferredScope;
  const requestedSubtype = urlParams.has('subtype') ? urlParams.get('subtype') : inferredSubtype;
  const allowedScopes = ['heritage', 'patches', 'ballcaps'];
  const allowedSubtypes = ['ss', 'ssn', 'ssbn'];

  if (allowedScopes.includes(requestedScope)) {
    scopeInput.value = requestedScope;
    scopeInput.defaultValue = requestedScope;
  }
  if (allowedSubtypes.includes(requestedSubtype)) {
    subtypeInput.value = requestedSubtype;
    subtypeInput.defaultValue = requestedSubtype;
  }

  document.querySelectorAll('.subvest-search__pagination a[href]').forEach((paginationLink) => {
    const paginationUrl = new URL(paginationLink.href, window.location.origin);

    if (customerDisplayQuery) paginationUrl.searchParams.set('subvest_query', customerDisplayQuery);
    if (urlParams.has('scope') || allowedScopes.includes(requestedScope)) paginationUrl.searchParams.set('scope', requestedScope);
    if (urlParams.has('subtype') || allowedSubtypes.includes(requestedSubtype)) paginationUrl.searchParams.set('subtype', requestedSubtype);

    paginationLink.href = paginationUrl.toString();
  });

  const searchLabels = {
    heritage: {
      heading: 'Search Heritage Shirts',
      label: 'Search Heritage Shirt product titles',
      placeholder: 'Search Heritage Shirts...'
    },
    patches: {
      heading: 'Search Patches',
      label: 'Search SUBVEST Patch product titles',
      placeholder: 'Search Patches...'
    },
    ballcaps: {
      heading: 'Search Ballcaps',
      label: 'Search SUBVEST Ballcap product titles',
      placeholder: 'Search Ballcaps...'
    }
  };
  const scopedLabels = searchLabels[scopeInput.value];

  if (scopedLabels) {
    const searchHeading = document.querySelector('[data-subvest-search-heading]');
    const searchLabel = subvestSearchForm.querySelector('[data-subvest-search-label]');
    const searchInput = subvestSearchForm.querySelector('[data-subvest-search-input]');

    if (searchHeading) searchHeading.textContent = scopedLabels.heading;
    if (searchLabel) searchLabel.textContent = scopedLabels.label;
    if (searchInput) searchInput.placeholder = scopedLabels.placeholder;
  }

  if (customerDisplayQuery) {
    const searchInput = subvestSearchForm.querySelector('[data-subvest-search-input]');

    if (searchInput) searchInput.value = customerDisplayQuery;
    document.querySelectorAll('.subvest-search__status strong').forEach((displayQuery) => {
      displayQuery.textContent = customerDisplayQuery;
    });
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-subvest-search-form]');

  if (!form) return;

  const visibleInput = form.querySelector('[data-subvest-search-input]');
  const queryInput = form.querySelector('[data-subvest-search-query]');
  const scopeInput = form.querySelector('[data-subvest-search-scope]');
  const subtypeInput = form.querySelector('[data-subvest-search-subtype]');
  const urlParams = new URLSearchParams(window.location.search);
  const currentQuery = urlParams.get('q') || '';
  const normalizedCurrentQuery = currentQuery.toLowerCase();
  const inferredScope = normalizedCurrentQuery.includes('title:"cloth"')
    ? 'heritage'
    : normalizedCurrentQuery.includes('title:"patch"')
      ? 'patches'
      : normalizedCurrentQuery.includes('title:"ballcap"')
        ? 'ballcaps'
        : '';
  const inferredSubtype = ['ssbn', 'ssn', 'ss'].find((value) => normalizedCurrentQuery.includes(`title:"${value}"`)) || '';
  const requestedScope = urlParams.has('scope') ? urlParams.get('scope') : inferredScope;
  const requestedSubtype = urlParams.has('subtype') ? urlParams.get('subtype') : inferredSubtype;
  const scope = ['heritage', 'patches', 'ballcaps'].includes(requestedScope) ? requestedScope : scopeInput?.value;
  const subtype = ['ss', 'ssn', 'ssbn'].includes(requestedSubtype) ? requestedSubtype : subtypeInput?.value;
  const customerQuery = visibleInput.value.trim().replace(/\s+/g, ' ');

  if (!customerQuery) {
    event.preventDefault();
    visibleInput.focus();
    return;
  }

  const safeQuery = customerQuery.replace(/["\\]/g, ' ');
  const normalizedCustomerQuery = safeQuery.toLowerCase();
  const titleSearchStopWords = new Set(['a', 'an', 'and', 'at', 'by', 'for', 'from', 'in', 'of', 'on', 'or', 'the', 'to', 'with']);
  const customerTitleTerms = normalizedCustomerQuery.split(/\s+/).filter(Boolean);
  const meaningfulTitleTerms = customerTitleTerms.filter((term) => !titleSearchStopWords.has(term));
  const titleTerms = meaningfulTitleTerms.length ? meaningfulTitleTerms : customerTitleTerms;
  const scopedQuery = titleTerms.map((term) => `title:"${term}"`);

  if (scopeInput) scopeInput.value = scope || '';
  if (subtypeInput) subtypeInput.value = subtype || '';

  if (['ss', 'ssn', 'ssbn'].includes(subtype)) scopedQuery.push(`title:"${subtype.toUpperCase()}"`);
  if (scope === 'heritage') scopedQuery.push('title:"Cloth"');
  if (scope === 'patches') scopedQuery.push('title:"PATCH"');
  if (scope === 'ballcaps') scopedQuery.push('title:"Ballcap"');

  queryInput.value = scopedQuery.join(' AND ');
});

const searchTitleCount = document.querySelector('[data-subvest-search-title-count]');

if (searchTitleCount) {
  const filteredCount = Number.parseInt(searchTitleCount.dataset.subvestFilteredCount, 10);
  const filteredTotalIsComplete = searchTitleCount.dataset.subvestFilteredTotalComplete === 'true';
  const rawCountPattern = /Search:\s+\d+\s+results?\s+found/i;

  const replaceRawCount = (title) => {
    if (!title || !rawCountPattern.test(title)) return title;

    if (!filteredTotalIsComplete) {
      return title.replace(rawCountPattern, 'Search results');
    }

    const resultLabel = filteredCount === 1 ? 'result' : 'results';
    return title.replace(rawCountPattern, `Search: ${filteredCount} ${resultLabel} found`);
  };

  document.title = replaceRawCount(document.title);

  document.querySelectorAll('meta[property="og:title"], meta[name="twitter:title"]').forEach((meta) => {
    meta.content = replaceRawCount(meta.content);
  });
}
